module.exports = __webpack_public_path__ + "media/entities/1117-85ba6bb9.png";